import type { RuleSet, Tiebreaker } from '../types.js';

/** Default-Tiebreaker-Kette aus docs/02 */
export const DEFAULT_TIEBREAKERS: Tiebreaker[] = ['points', 'headToHead', 'scoreDiff', 'scoreFor', 'wins', 'lot'];

const base: RuleSet = {
  teamSize: 2,
  matchFormat: { kind: 'single' },
  target: 21,
  winBy: 1,
  bust: 'off',
  onLimit: 'suddenDeath',
  draws: 'groupOnly',
  resultMode: 'score',
  points: { win: 3, draw: 1, loss: 0 },
  tiebreakers: DEFAULT_TIEBREAKERS,
  walkover: { winner: 21, loser: 0 },
  plannedMatchMinutes: 20,
  minRestMinutes: 0,
};

/** Regel-Presets aus docs/02 §3. Presets sind Daten — kopiert, nie referenziert. */
export const PRESETS = {
  /** ECO/ACL-Stil: 21, kein Bust, Sieg ab 21 */
  tournament: (): RuleSet => ({ ...base }),
  /** Viele Teams, wenig Felder */
  tournamentShort: (): RuleSet => ({
    ...base,
    target: 15,
    maxInnings: 8,
    timeLimitMin: 15,
    walkover: { winner: 15, loser: 0 },
    plannedMatchMinutes: 15,
  }),
  /** Freizeit: Bust auf 11, Sieg mit 2 */
  fun: (): RuleSet => ({ ...base, bust: 11, winBy: 2 }),
  /** Liga-Abend: Best-of-3 mit Zeitlimit */
  league: (): RuleSet => ({
    ...base,
    matchFormat: { kind: 'bestOf', sets: 3 },
    timeLimitMin: 20,
    plannedMatchMinutes: 45,
  }),
  singles: (): RuleSet => ({ ...base, teamSize: 1 }),
} as const;

export type PresetName = keyof typeof PRESETS;

export function preset(name: PresetName): RuleSet {
  return PRESETS[name]();
}

/** Effektives Regelwerk einer Phase: Bewerb + Phasen-Override */
export function effectiveRules(ruleSet: RuleSet, override?: Partial<RuleSet>): RuleSet {
  return override ? { ...ruleSet, ...override } : ruleSet;
}
